import { Box, DialogContent, DialogTitle, Typography, useTheme } from '@mui/material';

import { FormattedMessage } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import { FC } from 'react';
import { BackwardButton } from '../shared/backward-button';

interface TCProps {
  termsConditions: string;
  handleBackwardClick: () => void;
}

export const OfferTermsAndConditions: FC<TCProps> = ({
  termsConditions,
  handleBackwardClick,
}) => {
  const theme = useTheme();

  return (
    <>
      <DialogTitle>
        <BackwardButton handleClick={handleBackwardClick} />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            margin: 'auto',
          }}
        >
          <Typography
            sx={{
              textAlign: 'center',
              mt: '26px',
              fontWeight: 700,
              fontSize: {
                mobile: '18px',
                tablet: pxToRem(22),
              },
              lineHeight: '30px',
              mb: { tablet: pxToRem(24), mobile: '20px' },
            }}
          >
            <FormattedMessage id='terms.and.conditions' />
          </Typography>{' '}
        </Box>
        <Box sx={{ marginBlockEnd: 5 }}>
          <Typography
            id='offer-terms-text'
            component='p'
            dangerouslySetInnerHTML={{ __html: termsConditions as string }}
            sx={{
              [theme.breakpoints.down('tablet')]: {
                fontSize: '16px !important',
                '& span,p,a,q,div,b ,strong ,i ,em ,mark ,small,del,ins ,sub,sup': {
                  fontSize: '16px !important',
                },
                '& h1 ,h2': {
                  fontSize: '18px !important',
                  '& span': {
                    fontSize: '18px !important',
                  },
                },
                '& h3 ,h4': {
                  fontSize: '17px !important',
                  '& span': {
                    fontSize: '17px !important',
                  },
                },
              },
            }}
          />
        </Box>
      </DialogContent>
    </>
  );
};
